import React, { Component } from "react";
// import {
//   ReactiveBase,
// } from "@appbaseio/reactivesearch";
// import SingleList from "@appbaseio/reactivesearch/lib/components/list/SingleList";
// import ReactiveList from "@appbaseio/reactivesearch/lib/components/result/ReactiveList";
// import ResultList from "@appbaseio/reactivesearch/lib/components/result/ResultList";
import {
    Button,
    Tooltip
  } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TimelineIcon from '@mui/icons-material/Timeline';

const ElasticSearch = (props) => {
    const { index_name, analytics_panel_id } = props
    const [opengrafana, setOpengrafana] = React.useState(false);

    const handleClickOpenGrafana = () => {
      setOpengrafana(true);
    };
  
    const handleCloseGrafana = () => {
      setOpengrafana(false);
    };

    const grafanadomain = `${process.env.REACT_APP_GRAFANA_URL}/d/`;
    const org = "?orgId=1";
    const kiosk = "&kiosk";
    const AnalyticspanelID = `${analytics_panel_id}`;
    const grafanapanelurl = grafanadomain + AnalyticspanelID + org + kiosk;

    return (
      <>
        {/* <IconButton
        onClick={handleClickOpenGrafana}
        color="primary" aria-label="add an alarm">
        <DescriptionIcon />
      </IconButton> */}
      <Tooltip title="Usage Report" arrow>
        <Button
          onClick={handleClickOpenGrafana}
          variant="contained"
          color="primary"
          aria-label="add an alarm"
          sx={{ mx: 1,
            width: '85px',
            height: '25px',
           }}
        >
          Report
        </Button>
      </Tooltip>
      <Dialog
      open={opengrafana}
      onClose={handleCloseGrafana}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth='lg'
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">{`Account ID: ${index_name}`}</DialogTitle>
      <DialogContent>
      <div className="main-container">
      <iframe 
        src={grafanapanelurl} 
        // src="http://192.168.1.155:31069/d-solo/AVnnK1V4k/new-dashboard1?orgId=1&from=1664518800758&to=1665123600758&panelId=2" 
        width="1150" height="500" 
        frameborder="0"
        ></iframe>
        </div>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleCloseGrafana} color="primary">
          Disagree
        </Button> */}
        <Tooltip title="Close" arrow>
          <Button onClick={handleCloseGrafana} color="primary" autoFocus>
            Close
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>        
    </>
    );
}
export default ElasticSearch;